import React from 'react'
import PropTypes from 'prop-types'

import strings from 'utils/strings'

import { Header } from 'components/patterns'

import BoundariesTable from './BoundariesTable'
import withStyle from './Boundaries.style'

const Boundaries = ({
  lowerBoundFragments,
  upperBoundFragments,
  className,
}) => {
  return (
    <div className={className}>
      <Header type="h3">{strings.boundaries}</Header>

      {lowerBoundFragments && (
        <BoundariesTable
          title={strings.lower_boundary}
          dataSource={lowerBoundFragments}
        />
      )}
      {upperBoundFragments && (
        <BoundariesTable
          title={strings.upper_boundary}
          dataSource={upperBoundFragments}
        />
      )}
    </div>
  )
}

Boundaries.propTypes = {
  lowerBoundFragments: PropTypes.array,
  upperBoundFragments: PropTypes.array,
  className: PropTypes.string,
}

export default withStyle(Boundaries)
